<article class="container">
    <article class="row">
        <div class="col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 text-center m-top6">
            <p>Gracias por participar en esta transmisión, no será la última a la que te invitaremos. Con este mismo acceso podrás participar.</p>
            <p>Si tienes un tema de interés no dudes en compartirlo.</p>
        </div>
    </article>
    <article class="row">
        <div class="col text-center">
            <a href="https://redlarousse.mx/live/" class="btn-first">Ir al Inicio</a>
        </div>
    </article>
    <article class="row">
        <div class="col" style="height: 300px;">
        </div>
    </article>
</article>